/**
 * Pannello "Storico cliente" mostrato in OrderEditor — elenco degli ultimi
 * 100 articoli acquistati dal cliente selezionato con quantità, prezzo e
 * data dell'ultimo ordine.
 *
 * Estratto da OrderEditor.jsx per ridurne la dimensione.
 */
export function ClientHistoryPanel({
  loadingHistory,
  history,
  formItems,
  clientScontiFissi,
  onPickProduct,
}) {
  return (
    <div
      className="mt-2 max-h-72 overflow-y-auto border border-white/10 rounded-lg bg-[#0f0f12]"
      data-testid="client-history-panel"
    >
      {loadingHistory ? (
        <div className="px-3 py-4 text-center text-xs text-zinc-500">Caricamento storico…</div>
      ) : history.length === 0 ? (
        <div className="px-3 py-4 text-center text-xs text-zinc-500">Nessuno storico per questo cliente.</div>
      ) : (
        <ul className="divide-y divide-white/5">
          {history.slice(0, 100).map((h, idx) => {
            const alreadyInOrder = formItems.some((it) => it.product_id === h.id);
            return (
              <li
                key={`hist-${h.id}-${idx}`}
                data-testid={`client-history-item-${h.sku}`}
                className={`px-3 py-2 flex items-center gap-2 hover:bg-white/5 cursor-pointer ${alreadyInOrder ? "opacity-50" : ""}`}
                onClick={() => onPickProduct(h)}
              >
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white truncate">{h.name}</div>
                  <div className="text-[10px] text-zinc-500 flex items-center gap-2 flex-wrap">
                    {h.sku && <span className="font-mono">{h.sku}</span>}
                    <span className="text-cyan-300">{Number(h.ultima_qta).toLocaleString("it-IT")}</span>
                    {!clientScontiFissi && Number(h.ultimo_prezzo) > 0 && (
                      <span className="text-amber-300">·{Number(h.ultimo_prezzo).toFixed(2).replace(".", ",")}€</span>
                    )}
                    {h.ultima_data && (
                      <span className="text-zinc-500">{new Date(h.ultima_data).toLocaleDateString("it-IT")}</span>
                    )}
                    {alreadyInOrder && <span className="text-emerald-300">· già nell&apos;ordine</span>}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
